<div class="settings-container">
  <div class="settings-header">
    <div class="settings-title">
      <button class="mobile-menu-toggle" (click)="toggleMobileMenu()" aria-label="Toggle menu">
        <fa-icon [icon]="mobileMenuOpen ? faTimes : faBars"></fa-icon>
      </button>
      <h2>{{ 'SETTINGS.TITLE' | translate }}</h2>
    </div>
    <div class="settings-actions">
      <orbit-button
        [label]="'SETTINGS.CLOSE' | translate"
        (click)="closeSettings()"
        (keydown)="onCloseSettingsKeyDown($event)"></orbit-button>
    </div>
  </div>
  <div class="settings-content-wrapper">
    @if (mobileMenuOpen) {
      <button
        type="button"
        class="button-reset backdrop-overlay"
        (click)="closeMobileMenu()"
        (keydown)="onCloseMobileMenuKeyDown($event)"
        aria-label="Close menu"></button>
    }
    <div class="settings-sidebar" [class.mobile-menu-open]="mobileMenuOpen">
      <nav class="settings-nav">
        <ul>
          @for (item of navItems; track item.route) {
            <li>
              <a [routerLink]="[item.route]" routerLinkActive="active" (click)="closeMobileMenu()">
                {{ item.label | translate }}
              </a>
            </li>
          }
        </ul>
      </nav>
    </div>
    <div class="settings-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
